import React, { useState, useEffect } from "react";
import "./../../styles/components/dashboard/assets-percentage-list.css";
import DgSwitch from "../forms/DgSwitch";
import DgButton from "../DgButton";

function AssetsPercentageList({ data }) {
  //TODO there is no way of sasving changes yet

  const [assetData, setAssetData] = useState(data);

  const updateAssetPercentage = (asset, add) => {
    const unit = 5;

    setAssetData((prevAssetData) => {
      return prevAssetData.map((item) => {
        if (item.slug === asset && item.status === "active") {
          return {
            ...item,
            value: add ? item.value + unit : item.value - unit,
          };
        }
        return item;
      });
    });
  };

  const handleSwitch = (asset, switchState) => {
    setTimeout(() => {
      setAssetData((prevAssetData) => {
        return prevAssetData.map((item) => {
          if (item.slug === asset) {
            return {
              ...item,
              switch: switchState ? false : true,
            };
          }
          return item;
        });
      });
    }, 200);
  };

  useEffect(() => {
    setAssetData(data);
  }, [data]);

  return (
    <div className="component assets-percentage-list">
      <table>
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>100%</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data.map((asset, index) => (
            <tr key={index} className={asset.status || ""}>
              <td className="asset-logo">
                <img src="/assets/dell-logo.svg" alt="" />
              </td>
              <td className="asset-name">{asset.strategyName}</td>
              <td className="percentage">
                <div className="cont">
                  {asset.percentage}%
                  <div className="indicators">
                    <img
                      className="chevron"
                      src="/assets/icons/indicators/chevron-up.svg"
                      alt=""
                      onClick={() => updateAssetPercentage(index, true)}
                    />
                    <img
                      className="chevron"
                      src="/assets/icons/indicators/chevron-down.svg"
                      alt=""
                      onClick={() => updateAssetPercentage(index, false)}
                    />
                  </div>
                </div>
              </td>
              <td className="switch">
                <DgSwitch
                  checked={asset.switch}
                  action={() => handleSwitch(index, asset.switch)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
      {/* <DgButton
        category="primary"
        size="medium"
        text="View Portfolio"
      ></DgButton> */}
    </div>
  );
}

export default AssetsPercentageList;
